import {GridProps} from '@material-ui/core/Grid';
import {Breakpoint} from '@material-ui/core/styles/createBreakpoints';
import {OrderByPropType} from '../utils/orderByUtils';
import {Validator} from '../validation/validators';
import {FieldType, TypedFieldInfo} from '../TypedFormField';
import {Map} from 'immutable';
import {ExtendedWrappedFieldExternalProps} from '../FormFields';
import {ComplexCondition} from 'cl-table/redux/actions';

export interface FieldName<FormData extends object = {}> {
  name: keyof FormData;
}

export type DisabledByType = {[key: string]: ComplexCondition};

export interface FieldInfo<FormData extends object = {}> extends TypedFieldInfo, Pick<GridProps, Breakpoint> {
  section?: string;
  order?: number;
  type?: FieldType;
  validator?: Validator;
  infoIcon?: React.ReactNode;
  displayName?: string;
  disabled?: (row?: FormData, data?: Map<number, FormData>) => boolean;
  readOnly?: boolean;
  hidden?: boolean;
  orderBy?: OrderByPropType;
  units?: string;
  displayType?: DISPLAY_TYPES;
  addToSectionCount?: boolean;
  hideCreatedOption?: boolean;
  label?: React.ReactNode;
  countComponent?: React.ComponentType;
  disabledBy?: DisabledByType;
  defaultValue?: any;
}

export type FieldWithName<FormData extends object = {}> = FieldInfo<FormData> &
  FieldName<FormData> & {component?: ExtendedWrappedFieldExternalProps['component']; componentProps?: any};

export type FieldsInfo<FormData extends object = {}> = FieldWithName<FormData>[];

export interface SectionInfo<FormData extends object = {}> {
  name: string;
  fieldsInfo: FieldsInfo<FormData>;
}

export type FormSectionsOrder = string[];

export type FormInfo = {fields: FieldsInfo; sections: FormSectionsOrder; id: string};

export enum DISPLAY_TYPES {
  FREE_TEXT = 'freeText',
  TOGGLE = 'toggle',
  SINGLE_SELECT = 'singleSelect',
  RADIO_BUTTONS = 'radioButtons',
  TEXT_IN_EDITOR = 'textInEditor',
  MULTI_SELECT = 'multiSelect',
  CATEGORY_SELECTOR = 'categorySelector',
  TEMPLATE_SELECTOR = 'templateSelector',
  PHOTOS_PICKER = 'photosPicker',
  PHOTOS_PICKER_GROUP = 'photosPickerGroup',
  CUSTOM_ERROR = 'customerError',
  TABLE = 'table',
}
